// extracted by mini-css-extract-plugin
export var close = "Modal-module--close--f2e08";
export var modal = "Modal-module--modal--2c201";
export var modalBody = "Modal-module--modalBody--b5d50";
export var modalPlay = "Modal-module--modalPlay--9a3b3";
export var overlay = "Modal-module--overlay--a54e8";